// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_UMO","cls2":"PaperImages-cls2_m5S PaperImages-cls1_UMO"};